import { useRef, useEffect } from 'react';

export default function usePrevious<T>(value: T): T | null | undefined {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
